<template>
  <el-row style="margin-bottom: 10px;margin-top: -10px">
    <el-card class="box-card" style="margin-bottom: 5px">
        <span >
          <el-button type="primary" @click="showDlgAdd(null)">添加群链接</el-button>
          <el-button type="primary" @click="downAllUser">下载总报表</el-button>
          <el-button type="danger" @click="postClearData">清空所有</el-button>
        </span>

    </el-card>
    <el-col style="margin-top: -5px">
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="this.pagParams.page"
          :page-sizes="[20, 100, 200, 500]"
          :page-size="this.pagParams.limit"
          :total="this.pagParams.total"
          layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-col>
    <el-table
        class="el-ta"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        stripe
        border
        size="mini"
        highlight-current-row
        highlight-selection-row
    >

      <el-table-column
          type="selection"
          width="40px">
      </el-table-column>
<!--      <el-table-column-->
<!--          prop="sort"-->
<!--          label="序号"-->
<!--          width="80px"-->
<!--          sortable-->
<!--          show-overflow-tooltip>-->
<!--        <template slot-scope="scope">{{ scope.$index+1 }}</template>-->
<!--      </el-table-column>-->
      <el-table-column
          prop="lab"
          label="群编号"
          width="90px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="url"
          label="群链接"
          width="330px"
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="state"
          label="状态"
          width="100px"
          sortable
          :filters="[{ text: '停用', value: 0 }, { text: '启用', value: 1 }]"
          :filter-method="filterStatus"
          filter-placement="bottom-end"
      >
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.state === 0 ? 'danger' : 'success'"
              disable-transitions>{{scope.row.state === 1 ? '启用' : '停用'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="group_name"
          label="群名"
          width="150px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="count"
          label="群员人数"
          width="70px"
      >
      </el-table-column>
      <el-table-column
          prop="limit"
          label="群员限制"
          width="70px"
      >
      </el-table-column>
      <el-table-column
          prop="la_count"
          label="拉手人数"
          width="70px"
      >
      </el-table-column>
      <el-table-column
          prop="limit_enter"
          label="拉手限制"
          width="70px"
      >
      </el-table-column>

      <el-table-column
          prop="exist"
          label="重复过滤"
          width="80px"
      >
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.exist === 0 ? 'danger' : 'success'"
              disable-transitions>{{scope.row.exist === 1 ? '是' : '否'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="is_exit"
          label="拉完退群"
          width="80px"
      >
        <template slot-scope="scope">
          <el-tag
              :type="scope.row.is_exit === 0 ? 'danger' : 'success'"
              disable-transitions>{{scope.row.is_exit === 1 ? '是' : '否'}}</el-tag>
        </template>
      </el-table-column>

<!--      <el-table-column-->
<!--          prop="la_friend"-->
<!--          label="拉手好友数"-->
<!--          width="120px"-->
<!--      >-->
<!--      </el-table-column>-->



      <el-table-column
          prop="work"
          label="操作"
          width="280px">
        <template slot-scope="scope">
          <el-button icon="el-icon-s-custom" size="mini" @click="showDlgUserList(scope.row)">{{groupUser_count}}</el-button>
          <el-button icon="el-icon-edit" size="mini" @click="showDlgAdd(scope.row)">编辑</el-button>
          <el-button type="warning" icon="el-icon-error" size="mini" @click="postDelData(scope.row)">删除</el-button>
        </template>
      </el-table-column>

      <el-table-column
          prop="create_time"
          label="添加时间"
          width="150px"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
          prop="other"
          label="自定说明"
          sortable
          show-overflow-tooltip
      >
      </el-table-column>

    </el-table>

    <el-dialog
        :visible.sync="visUserList"
        width="30%"
        :title=memberTitle
    >

      <el-col>
        <el-button icon="el-icon-document-add" size="mini" @click="copyGroupList()" type="success" style="margin-bottom: 20px" >复制所有</el-button>
        <el-button icon="el-icon-document-add" size="mini" @click="exportExcel()" type="success" style="margin-bottom: 20px" >生成表格</el-button>
      </el-col>
<!--      <el-col>-->
<!--        <el-tag type="info">下载自动生成表格，必须是添加好友时使用自动备注</el-tag>-->
<!--      </el-col>-->

      <el-input type="textarea" :rows="30" v-model="userList" style="width: 100%"></el-input>

    </el-dialog>


    <el-dialog
        :visible.sync="visAdd"
        width="60%"
        :title=memberTitle
    >
      <el-form ref="form" :model="addForm" label-width="80px">
        <el-form-item label="群链接">
          <el-input  v-model="addForm.url" style="width: 100%"></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="群编号">
              <el-input v-model="addForm.lab" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="群员限制">
              <el-input v-model="addForm.limit" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="群员人数">
              <el-input v-model="addForm.count" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="群名称">
              <el-input v-model="addForm.group_name" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="拉手限制">
              <el-input v-model="addForm.limit_enter" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="拉手人数">
              <el-input v-model="addForm.la_count" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" >
            <el-form-item label="自定说明">
              <el-input v-model="addForm.other" style="width: 80%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="启用状态">
          <el-radio v-model="addForm.state" :label="0" border>停用</el-radio>
          <el-radio v-model="addForm.state" :label="1" border>启用</el-radio>
        </el-form-item>
        <el-form-item label="其他选项">

          <el-checkbox v-model="group_isExit">拉人完成后退群</el-checkbox>
          <el-checkbox v-model="group_isExist">重复好友过滤(全部群)</el-checkbox>
        </el-form-item>

        <el-form-item>
          <!--          <el-button @click="dialogVisible = false">取 消</el-button>-->
          <el-button type="primary" @click="postData">确 定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </el-row>
</template>

<script>

import { Base64 } from "js-base64";
import { timeago } from '@/utils/formatTime'
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from '@/utils/moment'

export default {
  data(){
    return {
      userName : window.sessionStorage.getItem('account'),
      intervalId: null,
      tmp:'',
      tableData: [],
      pagParams:{
        total:20,limit:20,page:1,searchval:''
      },

      addForm:{
        url:'',
        lab:'1',
        state:1,
        other:'',
        count:0,
        limit:40,
        exist:1,
        la_count:0,
        la_friend:0,
        is_exit:1,
        group_name:'',
        limit_enter:10
      },
      isSave:false,
      rules: {
        name: [
          { type: 'Number',required: true, message: '请输入', trigger: 'blur'},
          {min: 1, max: 3, message: '长度在 1 到 3 个字符', trigger: 'blur'}
        ],
      },

      userList:null,
      groupName:'',
      visChange:false,
      visAdd:false,
      visUserList:false,
      group_isDel:false,
      group_isExist:true,
      group_isExit:true,

      memberTitle:'当前群成员:',
      groupUser_count:'成员',

    }
  },
  created() {
    this.getList();
    this.intervalId = setInterval(this.getList, 3000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  },
  methods:{
    filterStatus(value, row) {
      return row.state === value;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pagParams.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pagParams.page = val;
      this.getList();
    },
    refreshData(){
      this.pagParams.page  = 1;
      // this.pagParams.limit = 5;
      // this.pagParams.total = 5;
      this.pagParams.searchval = '';
      this.getList();
    },
    showDlgSet(row){
      this.visChange = !this.visChange;
      if (this.visChange){
        this.addForm = row;
      }
    },
    showDlgUserList(row){
      this.visUserList = !this.visUserList;
      if(this.visUserList){
        // console.log(row);

        this.userList = row.group_user.toString().replace(/(;)/g, "\n");
        this.groupName = row.group_name;

        let arr = row.group_user.toString().split(';');
        this.memberTitle = "("+row.group_name+')已拉成员:'+(arr.length -1);

      }

    },
    showDlgAdd(row){
      this.visAdd = !this.visAdd;
      if (this.visAdd){
        if (row){
          this.addForm = row;
          this.isSave  = true;
        }else {
          this.addForm.url = '';
          this.addForm.lab = this.tableData.length+1;
          this.addForm.state = 1;
          this.addForm.other = '';
          this.isSave  = false;
        }


        row.exist === 1 ? this.group_isExist = true: this.group_isExist = false;
        row.is_exit === 1 ? this.group_isExit = true: this.group_isExit = false;
      }

    },
    downAllUser(){

      let uAll = this.tableData;
      // console.log(uAll);

      let users = [];
      for (let i = 0; i <uAll.length; i++) {
        let nLine = uAll[i].group_user.split(';');
        if(!uAll[i].group_name) uAll[i].group_name = "无";

        for (let j = 0; j < nLine.length; j++) {
          if (nLine[j]){
            users.push(uAll[i].group_name +"/"+ nLine[j]);
          }

        }

      }

      if (users){
        // console.log(users.toString());
        this.exportExcel_all(users.join("\n"));
      }

    },
    copyGroupList(){
      this.$copyText(this.userList.replace(/( |null)/g, '')).then(
          (e) => {
            this.$msgNot.success("复制成功");
          },
          (err) => {
            this.$msgNot.success("复制失败");
          }
      );
    },

    async postDelData(row){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }
      await this.$msgBox.confirm('确认删除？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/group/delData",{'account':this.userName,'data':row});
            if (res.code === 200){
              this.czVisible = false;
              this.$msgNot.success(res.msg);
              await this.getList();
            }else {
              this.$msgNot.error(res.msg);
            }

          }).catch(()=>{

          });

    },

    async postClearData(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      await this.$msgBox.confirm('确认清空所有数据？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data:res} = await this.$ajax.post("/api/group/clearData",{'account':this.userName});
            if (res.code === 200){
              this.$msgNot.success('清空成功');
              await this.getList();
            }else {
              this.$msgNot.err('清空失败:'+res.msg);
            }

          }).catch(()=>{

          });
    },

    async postData() {
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }


      this.group_isExist ? this.addForm.exist = 1 : this.addForm.exist = 0;
      this.group_isExit ? this.addForm.is_exit = 1 : this.addForm.is_exit = 0;

      // console.log(this.addForm);
      await this.$msgBox.confirm('确认添加链接？','提示',{confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning',})
          .then(async ()=>{
            const {data: res} = await this.$ajax.post("/api/group/addData", {'account': this.userName, 'save':this.isSave,'data':this.addForm});
            if (res.code === 200) {
              this.$msgNot.success(res.msg);
              this.visAdd = false;
              await this.getList();
            } else {
              this.$msgNot.error(res.msg);
            }

          }).catch(()=>{

          });
    },
    async getList(){
      if (!this.userName) {
        this.$msgNot.error('登录状态异常,请重新登录');
        return;
      }

      const {data:res} = await this.$ajax.post("/api/group/getList",{'account':this.userName,'data':this.pagParams});
      if (res.code === 200){
        this.tableData = res.data;
        this.pagParams.total = res.total;


      }else {
        this.$msgNot.error('失败:'+res.msg);
      }

    },
    formatDate(row, column) {
      if(!row[column.property]) return '';

      let date = new Date(row[column.property] * 1000)
      const Y = date.getFullYear() + '-'
      const M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      const D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      const h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      const m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D + h + m + s
    },
    calculateDays(caTime) {
      let t = (caTime - (Date.now() /1000)) / 86400;
      let s = Math.floor(t+1)+'天';
      if (t < 0) s ="过期"
      return s;
    },
    timeAgo(val) {
      return timeago(val)
    },
    exportExcel() {
      let data = [
        ['序号','群名', '手机','备注','昵称','钉钉号']
      ];
      let arrLine = this.userList.trim().split('\n');
      // console.log(this.userList);

      let arr = []
      let arr2 = [];
      let count = 0;

      console.log(arrLine.length);

      for (let i = 0; i < arrLine.length; i++) {
        arr = arrLine[i].split('/');
        if(arr){
          count++
          for (let j = 0; j < arr.length; j++) {
            arr2 = [];
            arr2.push(count);           //序号
            arr2.push(this.groupName);  //群名
            arr2.push(arr[1]);          //手机
            arr2.push(arr[2] ? arr[2] : arr[3]);          //备注
            arr2.push(arr[3] ? arr[3] : arr[2]);          //昵称
            arr2.push(arr[4]);          //钉钉号

            // if (arr.length > 3){
            //   arr2.push(arr[2]);      //备注
            //   arr2.push(arr[3]);      //昵称
            //   arr2.push(arr[4]);      //钉钉号
            // }else if (arr.length > 2){
            //   arr2.push(arr[2]);
            //   if (arr[3] === ''){
            //     arr2.push(arr[2]);
            //   }
            // }else {
            //   arr2.push("");
            //   arr2.push(arr[0]);
            // }
          }
          data.push(arr2);
        }

      }


      // 创建工作簿
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.SSF.format('yyyy-mm-dd', new Date());
      XLSX.utils.book_append_sheet(wb, ws, this.groupName);

      // 生成文件并保存
      const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(blob, this.groupName+'_.xlsx');
    },
    exportExcel_all(users) {
      let data = [
        ['序号','群名', '手机','备注','昵称','钉钉号']
      ];

      console.log(users);

      let arr = []
      let arr2 = [];
      let count = 0;

      let arrLine = users.trim().split('\n');


      for (let i = 0; i < arrLine.length; i++) {
        arr = arrLine[i].split('/');
        console.log(arr.length);

        if(arr){
          count++
          for (let j = 0; j < arr.length; j++) {
            arr2 = [];
            arr2.push(count);           //序号
            arr2.push(arr[0]);          //群名
            arr2.push(arr[2]);          //手机
            arr2.push(arr[3] ? arr[3] : arr[4]);          //备注
            arr2.push(arr[4] ? arr[4] : arr[3]);          //昵称
            arr2.push(arr[5]);          //钉钉号


            // arr2.push(count);         //序号
            // arr2.push(arr[0]);        //群名
            // arr2.push(arr[2]);        //手机
            //
            //
            // if (arr.length > 3){
            //   arr2.push(arr[3]);      //备注
            //   arr2.push(arr[4]);      //昵称
            //   arr2.push(arr[5]);      //钉钉号
            // }else if (arr.length > 2){
            //   arr2.push(arr[3]);
            // }else {
            //   arr2.push("");
            //   arr2.push(arr[1]);
            // }
          }


          data.push(arr2);
        }

      }


      // 创建工作簿
      const ws = XLSX.utils.aoa_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.SSF.format('yyyy-mm-dd', new Date());
      XLSX.utils.book_append_sheet(wb, ws, this.groupName);

      // 生成文件并保存
      const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([buffer], { type: 'application/octet-stream' });

      saveAs(blob, moment().format('YYYY-MM-DD') + ' 总报表_'+this.userName+'.xlsx');
    }

  },
}
</script>

<style scoped>
.el-ta {
  /*background-color: #222D32;*/
  color: #000000;
  text-align: left;
  /*line-height: 150px;*/
  margin: 1px;
  padding: 1px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
</style>
